export default __webpack_public_path__ + "static/media/11.18.ac8cbdbc.jpg";